export default {
  api_r_user_module_correctiveActions_getModuleData: {
    path: 'm/corrective-actions/get-module-data/',
  },
  api_r_user_module_correctiveActions_getPermissions: {
    path: 'm/corrective-actions/get-permissions/',
  },
  api_r_user_module_correctiveActions_task_list_getNavbarInfo: {
    path: 'm/corrective-actions/task/list/get-navbar-info/',
  },
  api_r_user_module_correctiveActions_task_list_generateFilterHexCode: {
    path: 'm/corrective-actions/task/list/generate-filter-hex-code/',
  },
  api_r_user_module_correctiveActions_task_list_generateFilterHexCodeForDependency: {
    path: 'm/corrective-actions/task/list/generate-filter-hex-code-for-dependency/',
  },
  api_r_user_module_correctiveActions_task_list_getFilters: {
    path: 'm/corrective-actions/task/list/get-filters/',
  },
  api_r_user_module_correctiveActions_task_list_setUserMark: {
    path: 'm/corrective-actions/task/list/set-user-mark/',
  },
  api_r_user_module_correctiveActions_task_list: {
    path: 'm/corrective-actions/task/list/',
  },
  api_r_user_module_correctiveActions_task_get: {
    path: 'm/corrective-actions/task/get/',
  },
  api_r_user_module_correctiveActions_task_add: {
    path: 'm/corrective-actions/task/add/',
  },
  api_r_user_module_correctiveActions_task_edit: {
    path: 'm/corrective-actions/task/edit/',
  },
  api_r_user_module_correctiveActions_task_delete: {
    path: 'm/corrective-actions/task/delete/',
  },
  api_r_user_module_correctiveActions_task_deleteConfirm: {
    path: 'm/corrective-actions/task/delete-confirm/',
  },
  api_r_user_module_correctiveActions_task_close: {
    path: 'm/corrective-actions/task/close/',
  },
  api_r_user_module_correctiveActions_task_closeRequest: {
    path: 'm/corrective-actions/task/close-request/',
  },
  api_r_user_module_correctiveActions_task_responsible_delegate: {
    path: 'm/corrective-actions/task/responsible/delegate/',
  },
  api_r_user_module_correctiveActions_task_review_list: {
    path: 'm/corrective-actions/task/review/list/',
  },
  api_r_user_module_correctiveActions_task_review_add: {
    path: 'm/corrective-actions/task/review/add/',
  },
  api_r_user_module_correctiveActions_task_review_edit: {
    path: 'm/corrective-actions/task/review/edit/',
  },
  api_r_user_module_correctiveActions_task_review_delete: {
    path: 'm/corrective-actions/task/review/delete/',
  },
  api_r_user_module_correctiveActions_task_loadLevel: {
    path: 'm/corrective-actions/task/load-level/',
  },
  api_r_user_module_correctiveActions_tasks_user_list: {
    path: 'm/corrective-actions/tasks/user/list/',
  },
  api_r_user_module_correctiveActions_taskUpdate_list: {
    path: 'm/corrective-actions/task-update/list/',
  },
  api_r_user_module_correctiveActions_taskUpdate_add: {
    path: 'm/corrective-actions/task-update/add/',
  },
  api_r_user_module_correctiveActions_taskUpdate_edit: {
    path: 'm/corrective-actions/task-update/edit/',
  },
  api_r_user_module_correctiveActions_taskUpdate_delete: {
    path: 'm/corrective-actions/task-update/delete/',
  },
  api_r_user_module_correctiveActions_taskUpdate_changeState: {
    path: 'm/corrective-actions/task-update/change-state/',
  },
  api_r_user_module_correctiveActions_taskUpdate_downloadFile: {
    path: 'm/corrective-actions/task-update/download-file/',
  },
  api_r_user_module_correctiveActions_taskUpdate_getEditLists: {
    path: 'm/corrective-actions/task-update/get-edit-lists/',
  },
  api_r_user_module_correctiveActions_taskUpdate_changeClosedStamp: {
    path: 'm/corrective-actions/task-update/change-closed-stamp/',
  },
  // Report
  api_r_user_module_correctiveActions_report_task_xls: {
    path: 'm/corrective-actions/report/task/xls/',
  },
  api_r_user_module_correctiveActions_report_doc_edp: {
    path: 'm/corrective-actions/report/doc/edp/',
  },
  // Notifications
  api_r_user_module_correctiveActions_notifications_get: {
    path: 'm/corrective-actions/notifications/get/',
  },
  api_r_user_module_correctiveActions_notifications_set: {
    path: 'm/corrective-actions/notifications/set/',
  },
};
